import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', () => {
    
    // Initialize Lightbox once (GLightbox handles multiple instances internally)
    if (document.querySelector('.glightbox')) {
        GLightbox({
            selector: '.glightbox',
            touchNavigation: true,
            autoplayVideos: true,
            zoomable: true,
            draggable: true,
            openEffect: 'fade',
            closeEffect: 'fade',
        });
    }

    // Process all Pattern-8 blocks in a single loop
    const patternBlocks = document.querySelectorAll('.section-pattern-8-block');

    patternBlocks.forEach(block => {
        // Button Cloning
        const desktopButtons = block.querySelector('.visible-desktop.buttons');
        const mobileButtons = block.querySelector('.visible-mobile.buttons');

        if (desktopButtons && mobileButtons && !mobileButtons.innerHTML.trim()) {
            mobileButtons.innerHTML = desktopButtons.innerHTML;
        }

        // Cinematic Video Autoplay
        // We look for wrappers only within this specific block
        const animatedWrappers = block.querySelectorAll('.foxtrot-animated-video');

        animatedWrappers.forEach(wrapper => {
            const overlay = wrapper.querySelector('.foxtrot-video-overlay');
            if (!overlay) return;

            overlay.addEventListener('click', (e) => {
                e.preventDefault();
                wrapper.classList.add('is-active');

                const videoEl = wrapper.querySelector('video');
                const iframeEl = wrapper.querySelector('iframe');

                if (videoEl) {
                    videoEl.muted = false;
                    videoEl.controls = true;
                    videoEl.loop = false;
                    videoEl.currentTime = 0;
                    videoEl.play().catch(err => console.warn("Video play blocked:", err));
                }

                if (iframeEl) {
                    iframeEl.style.pointerEvents = 'auto';
                    const url = new URL(iframeEl.src);
                    
                    // Efficiently update URL parameters
                    url.searchParams.set('mute', '0');
                    url.searchParams.set('muted', '0');
                    url.searchParams.set('controls', '1');
                    url.searchParams.set('background', '0');
                    url.searchParams.set('autoplay', '1');

                    iframeEl.src = url.toString();
                }
            }, { once: true }); // Optimization: Listener is removed after the first click
        });
    });
});